(function (angular) {
    'use strict';

    angular
        .module('app.support')
        .service('supportService', [
            "$http",
            supportService
        ]);

    function supportService($http) {
        return {
            getStates: getStates,
            getSellableStatesByPlan: getSellableStatesByPlan
        };

        function getStates() {
            return [
                { name: "Alabama", value: "Alabama", abbr: "AL" },
                { name: "Alaska", value: "Alaska", abbr: "AK" },
                { name: "Arizona", value: "Arizona", abbr: "AZ" },
                { name: "Arkansas", value: "Arkansas", abbr: "AR" },
                { name: "California", value: "California", abbr: "CA" },
                { name: "Colorado", value: "Colorado", abbr: "CO" },
                { name: "Connecticut", value: "Connecticut", abbr: "CT" },
                { name: "Delaware", value: "Delaware", abbr: "DE" },
                { name: "District of Columbia", value: "District_of_Columbia", abbr: "DC" },
                { name: "Florida", value: "Florida", abbr: "FL" },
                { name: "Georgia", value: "Georgia", abbr: "GA" },
                { name: "Hawaii", value: "Hawaii", abbr: "HI" },
                { name: "Idaho", value: "Idaho", abbr: "ID" },
                { name: "Indiana", value: "Indiana", abbr: "IN" },
                { name: "Iowa", value: "Iowa", abbr: "IA" },
                { name: "Kansas", value: "Kansas", abbr: "KS" },
                { name: "Kentucky", value: "Kentucky", abbr: "KY" },
                { name: "Louisiana", value: "Louisiana", abbr: "LA" },
                { name: "Maine", value: "Maine", abbr: "ME" },
                { name: "Maryland", value: "Maryland", abbr: "MD" },
                { name: "Massachusetts", value: "Massachusetts", abbr: "MA" },
                { name: "Michigan", value: "Michigan", abbr: "MI" },
                { name: "Minnesota", value: "Minnesota", abbr: "MN" },
                { name: "Mississippi", value: "Mississippi", abbr: "MS" },
                { name: "Missouri", value: "Missouri", abbr: "MO" },
                { name: "Montana", value: "Montana", abbr: "MT" },
                { name: "Nebraska", value: "Nebraska", abbr: "NE" },
                { name: "Nevada", value: "Nevada", abbr: "NV" },
                { name: "New Hampshire", value: "New_Hampshire", abbr: "NH" },
                { name: "New Jersey", value: "New_Jersey", abbr: "NJ" },
                { name: "New Mexico", value: "New_Mexico", abbr: "NM" },
                { name: "New York", value: "New_York", abbr: "NY" },
                { name: "North Carolina", value: "North_Carolina", abbr: "NC" },
                { name: "North Dakota", value: "North_Dakota", abbr: "ND" },
                { name: "Ohio", value: "Ohio", abbr: "OH" },
                { name: "Oklahoma", value: "Oklahoma", abbr: "OK" },
                { name: "Oregon", value: "Oregon", abbr: "OR" },
                { name: "Pennsylvania", value: "Pennsylvania", abbr: "PA" },
                { name: "Rhode Island", value: "Rhode_Island", abbr: "RI" },
                { name: "South Carolina", value: "South_Carolina", abbr: "SC" },
                { name: "South Dakota", value: "South_Dakota", abbr: "SD" },
                { name: "Tennessee", value: "Tennessee", abbr: "TN" },
                { name: "Texas", value: "Texas", abbr: "TX" },
                { name: "Utah", value: "Utah", abbr: "UT" },
                { name: "Vermont", value: "Vermont", abbr: "VT" },
                { name: "Virginia", value: "Virginia", abbr: "VA" },
                { name: "Washington", value: "Washington", abbr: "WA" },
                { name: "West Virginia", value: "West_Virginia", abbr: "WV" },
                { name: "Wisconsin", value: "Wisconsin", abbr: "WI" },
                { name: "Wyoming", value: "Wyoming", abbr: "WY" }
            ];
        }

        function getSellableStatesByPlan(planName) {
            return $http.get(environment.salesApiUrl + "plans/get-sellable-states-by-plan?planName=" + planName);
        }
    }
})(angular);
